import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { useTheme } from '@paypalcorp/pp-react-theme';
import { Shimmer } from '@paypalcorp/pp-react-utils';
import '../__generated__/styles/links.css';

var styles = {"ppvx_link":"ppvx_link___3-6-7","ppvx_icon":"ppvx_icon___3-6-7","ppvx_link__left-icon":"ppvx_link__left-icon___3-6-7","ppvx_link--inverse":"ppvx_link--inverse___3-6-7","ppvx_link--secondary":"ppvx_link--secondary___3-6-7","ppvx_link__shimmer":"ppvx_link__shimmer___3-6-7","ppvx--v2":"ppvx--v2___3-6-7","ppvx--v1":"ppvx--v1___3-6-7"};

var Link = forwardRef(function (_ref, ref) {
  var _clsx;

  var inverse = _ref.inverse,
      secondary = _ref.secondary,
      className = _ref.className,
      leftIcon = _ref.leftIcon,
      children = _ref.children,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'a' : _ref$as,
      theme = _ref.theme,
      isLoading = _ref.isLoading,
      rest = _objectWithoutProperties(_ref, ["inverse", "secondary", "className", "leftIcon", "children", "as", "theme", "isLoading"]);

  // If theme is not directly provided, get from themeContext
  var _theme = useTheme('Link', theme);

  var isV2 = _theme && _theme === 'v2';

  if (isV2 && isLoading) {
    return /*#__PURE__*/React.createElement(Shimmer, {
      className: clsx(styles.ppvx_link__shimmer, className),
      hasStyleDefaults: false,
      isInverse: inverse
    }, children);
  }

  if (as === 'a' && rest.target === '_blank') {
    if (!rest.rel) {
      rest.rel = 'noreferrer noopener';
    } else {
      if (!/noreferrer/i.test(rest.rel)) {
        rest.rel = "".concat(rest.rel, " noreferrer");
      }

      if (!/noopener/i.test(rest.rel)) {
        rest.rel = "".concat(rest.rel, " noopener");
      }
    }
  }

  var leftIconElm = leftIcon && /*#__PURE__*/React.createElement("span", {
    className: styles['ppvx_link__left-icon']
  }, leftIcon);
  var cls = clsx(styles.ppvx_link, (_clsx = {}, _defineProperty(_clsx, styles['ppvx_link--inverse'], inverse), _defineProperty(_clsx, styles['ppvx_link--secondary'], secondary), _clsx), isV2 && styles['ppvx--v2'], className);
  return /*#__PURE__*/React.createElement(as, _extends({
    className: cls,
    ref: ref
  }, rest), leftIconElm, children);
});

export { Link };
